import React, { useEffect, useState } from "react";
import {
  GetSessionKonseling,
  GetSessionKonselingStatus,
  StopSessionKonseling,
} from "../actions/SessionKonselingActions";
import { useDispatch, useSelector } from "react-redux";
import {
  isAfterFromServerGMT0,
  isAfterFromServerGMT0PlushDuration,
} from "../function/dateTimeCustomeFunction";
import {
  VC_CLOSE,
  VC_ROOM,
  WAITING_ROOM,
} from "../constants/SessionKonselingConstants";
import { StartRecordingPduli } from "../actions/recordingActions";

export default function useSessionDataPduli(props) {
  const { sessionId = null } = props;
  const [data, setData] = useState({});
  const [statusRoom, setStatusRoom] = useState(WAITING_ROOM);
  const [idServerRecord, setIdServerRecord] = useState(null);
  const [isUserLeave, setIsUserLeave] = useState(false);
  const dispatch = useDispatch();
  const storeGet = useSelector((state) => state.km_get_session_konseling);
  const storeGetStatus = useSelector(
    (state) => state.km_get_session_konseling_status
  );
  const storeRecord = useSelector((state) => state.pduli_recording);
  const storeRecordStop = useSelector(
    (state) => state.km_stop_session_konseling
  );
  useEffect(() => {
    if (sessionId != null) {
      dispatch(GetSessionKonseling());
    }
  }, [sessionId]);

  useEffect(() => {
    if (storeGet.success) {
      setData(storeGet?.data);
      let statusRoomTmp = WAITING_ROOM;
      let statusSessionServer = storeGet?.data?.session?.status;
      if (
        isAfterFromServerGMT0(
          storeGet?.data?.session?.date,
          storeGet?.data?.session?.startTime
        )
      ) {
        statusRoomTmp = VC_ROOM;
      }
      if (
        isAfterFromServerGMT0PlushDuration(
          storeGet?.data?.session?.date,
          storeGet?.data?.session?.startTime,
          storeGet?.data?.session?.duration
        )
      ) {
        statusRoomTmp = VC_CLOSE;
      }
      if (statusSessionServer == "Waiting Report") {
        statusRoomTmp = VC_CLOSE;
      }
      setStatusRoom(statusRoomTmp);
    }
    if (storeGet.error) {
    }
  }, [storeGet]);

  useEffect(() => {
    if (storeGetStatus.success) {
      let statusSessionServer = storeGetStatus?.data?.session?.status;
      if (statusSessionServer == "Waiting Report") {
        setIsUserLeave(true);
      }
    }
    if (storeGetStatus.error) {
    }
  }, [storeGetStatus]);

  useEffect(() => {
    if (storeRecord.success) {
      setIdServerRecord(storeRecord?.data);
    }
  }, [storeRecord]);
  useEffect(() => {
    if (storeRecordStop.success) {
      setIsUserLeave(true);
    }
    if (storeRecordStop.error) {
      setIsUserLeave(true);
    }
  }, [storeRecordStop]);
  const handleOpenRoom = () => {
    setStatusRoom(VC_ROOM);
  };

  const handleCLoseRoom = () => {
    setStatusRoom(VC_CLOSE);
    dispatch(StopSessionKonseling(idServerRecord));
  };
  const handleCLoseRoomByServer = () => {
    dispatch(StopSessionKonseling(idServerRecord));
  };

  const handleForceCloseRoom = () => {
    setStatusRoom(VC_CLOSE);
  };

  const handleStartRecord = () => {
    dispatch(StartRecordingPduli());
  };

  const handleReGetData = () => {
    // console.log("triger close VC: tahap 4");
    dispatch(GetSessionKonselingStatus());
  };
  return {
    loading: storeGet?.loading,
    dataSessionPduli: data,
    handleOpenRoom,
    handleCLoseRoom,
    handleCLoseRoomByServer,
    handleStartRecord,
    handleReGetData,
    handleForceCloseRoom,
    isWaitingRoom: statusRoom == WAITING_ROOM,
    isRoomClose: statusRoom == VC_CLOSE,
    isRoomOpen: statusRoom == VC_ROOM,
    forceClose: isUserLeave,
    roomStatus: statusRoom,
  };
}
